import { createFileRoute } from "@tanstack/react-router";

import DeliveryDetail from "@/components/[routes]/deliveries/deliveries-detail";

export const Route = createFileRoute("/_secure/deliveries/$reference")({
  component: DeliveryDetail,
});
